import { render, staticRenderFns } from "./MarginalCost.vue?vue&type=template&id=22873362&"
import script from "./MarginalCost.vue?vue&type=script&lang=js&"
export * from "./MarginalCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports